module.exports = __webpack_public_path__ + "img/23_34.7564aa39.png";